<template>
    <report
        :report="report"
        :versions="versions"
        :loading="loading"
        :refreshing="refreshing"
        export-url="/report/billing-schedule/export"
        @reload="reload"
        @load-version="load_version"
    >
        <div class="lam-graph-container">
            <div class="uk-grid uk-grid-small uk-grid-width-1-2">
                <div>
                    <div class="uk-flex">
                        <div>
                            <ul class="uk-subnav uk-subnav-line">
                                <li class="uk-disabled"><a href="">Studio</a></li>
                                <li :class="{'uk-active': !state.studio_id}"><a href @click.prevent="set_state_value('studio_id', '')">All</a></li>
                                <li
                                    v-for="studio in studios"
                                    :key="studio.id"
                                    :class="{'uk-active': state.studio_id === studio.id}"
                                >
                                    <a href @click.prevent="set_state_value('studio_id', studio.id)">{{ studio.name }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="uk-text-right">
                    <div class="uk-button-group lam-graph-filter">
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 3}"
                            @click.prevent="set_scope(3)"
                        >
                            3 months
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 6}"
                            @click.prevent="set_scope(6)"
                        >
                            6 months
                        </base-button>
                        <base-button
                            size="mini"
                            :class="{'uk-active': state.scope === 12}"
                            @click.prevent="set_scope(12)"
                        >
                            1 year
                        </base-button>
                    </div>
                </div>
            </div>
            <div class="uk-grid uk-grid-small uk-margin-bottom lam-graph">
                <div class="uk-width-1-1" style="position: relative;">
                    <billing-schedule-graph
                        ref="chart"
                        :chart-data="chart_data"
                        :y-max="ymax"
                        style="height: 600px;"
                        @click="route_to_record"
                    />
                </div>
            </div>
        </div>
    </report>
</template>

<script type="text/javascript">
import is_big_report from "./IsBigReport"
import handles_projects from "./HandlesProjects"

import Report from "./Report.vue"
import BaseButton from "../../ui/BaseButton"
import BillingScheduleGraph from "./BillingScheduleGraph.js"

export default {
    mixins: [is_big_report, handles_projects],
    components: {
        Report,
        BaseButton,
        BillingScheduleGraph
    },
    computed: {
        chart_data () {
            const data = { labels: [], datasets: [] }
            const range_start = this.$moment().startOf("month")
            const range_end = this.$moment(range_start).add(this.state.scope, "months")

            if(this.report) {
                const report_dataset = this.report.dataset

                const project_identifiers = Object.keys(report_dataset)
                if(project_identifiers.length) {
                    Object.keys(report_dataset[project_identifiers[0]]).forEach(date_string => {
                        const date = this.$moment(date_string)
                        if(date.isSameOrAfter(range_start) && date.isBefore(range_end)) {
                            data.labels.push(date.format("MMM Do"))
                        }
                    })
                }

                project_identifiers.forEach(project_identifier => {
                    const project_id = parseInt(project_identifier.replace(/^[^\d]+/, ""))
                    const project = this.entity_record("project", parseInt(project_id)) || {}
                    if(project && (!this.state.studio_id || (project.studio_ids.indexOf(this.state.studio_id) >= 0))) {
                        const dataset = {
                            label: this.nibnut_filter("nibnut.smart-truncate", [project.number + (parseInt(project.number_suffix) ? `.${project.number_suffix}` : "") + " " + project.name, 30]),
                            backgroundColor: project.hex_color,
                            borderColor: "#ffffff",
                            borderWidth: 1,
                            categoryPercentage: 0.9,
                            barPercentage: 0.8,
                            fill: false,
                            data: [],
                            project: project
                        }

                        Object.keys(report_dataset[project_identifier]).forEach(date_string => {
                            const date = this.$moment(date_string)
                            if(date.isSameOrAfter(range_start) && date.isBefore(range_end)) {
                                dataset.data.push(parseFloat(report_dataset[project_identifier][date_string]))
                            }
                        })

                        data.datasets.push(dataset)
                    }
                })

                // eslint-disable-next-line
                this.ymax = 0
                for(let loop = 0; loop < data.labels.length; loop++) {
                    let period_total = 0
                    data.datasets.forEach(dataset => {
                        period_total += parseInt(dataset.data[loop]) || 0
                    })
                    // eslint-disable-next-line
                    this.ymax = Math.max(period_total, this.ymax)
                }
            }

            return data
        }
    },
    data () {
        return {
            report_id: "billing-schedule",
            fields: ["ns::project;fieldset::graph"],

            default_state: {
                scope: 6, // nb months
                mode: "absolute",
                filter: "",
                user_id: 0,
                studio_id: 0,
                version_id: 0
            }
        }
    }
}
</script>
